module.exports = __webpack_public_path__ + "img/03.e02c492f.jpg";